import React, { Component } from 'react';
import { connect } from 'react-redux';

//import * as Media from '../../utils/Breakpoints'
import VisibilitySensor from 'react-visibility-sensor';
import moment from 'moment';
//import {TweenMax, Linear} from "gsap/TweenMax"
import TWEEN from '@tweenjs/tween.js';
import isTouchDevice from 'is-touch-device';

import classNames from 'classnames';

import { bindActionCreators } from 'redux';
import * as ACTIONS from '../../redux/actions/UI';

function mapDispatchToProps(dispatch) {
  return {
    projectClick: bindActionCreators(ACTIONS.projectClick, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    projectClicked: state.UI.projectClicked,
  };
}

// eslint-disable-next-line
Number.prototype.pad = function (size) {
  var s = String(this);
  while (s.length < (size || 2)) {
    s = '0' + s;
  }
  return s;
};

class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playButton: 'Play',
      playPause: 'is-playing',
      min: 0,
      sec: 0,
      transition: 'transition-on',
      hover: '',
      isPlaying: false,
    };

    this.togglePlay = this.togglePlay.bind(this);

    /*this.onChange = this.onChange.bind(this);
    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
    this.timer = this.timer.bind(this);
    this.seek = this.seek.bind(this);
    this._mouseEnter = this._mouseEnter.bind(this);
    this._mouseLeave = this._mouseLeave.bind(this);*/
  }

  /*onChange(isVisible) {

  	if(isVisible) {
  		this.refs.video.play();
  	} else {
  		this.refs.video.pause();
  	}
  
  }*/

  /*_mouseEnter() {
  	this.setState({"hover": "is-hover"});
  }

  _mouseLeave() {
  	this.setState({"hover": ""});
  }*/

  /*togglePlayPause(event) {
  	
  	let video = this.refs.video;
  	let playpause = event.target;

  	if (video.paused || video.ended) {
      playpause.title = "pause";
     
      this.setState({ "playPause": "is-playing", "playButton": "Pause", "transition": "transition-on"});

      video.play();
   }
   else {
      playpause.title = "play";
     
      this.setState({ "playPause": "is-not-playing", "playButton": "Play", "transition": "transition-off"});

      video.pause();
   }
  }*/

  togglePlay = (visible) => {
    let { player } = this.refs;

    if (visible) {
      player.play();
      this.setState({
        isPlaying: true,
      });
    } else {
      player.pause();
      this.setState({
        isPlaying: false,
      });
    }
  };

  updateProgress() {
    let video = this.refs.video;
    let progress = this.refs.progress;
    let value = 0;

    if (video.currentTime > 0 && video !== undefined) {
      value = Math.floor((100 / video.duration) * video.currentTime);
    }

    // TweenMax.to(progress, 1, {left: value+"%"});
    progress.style.left = value + '%';
  }

  timer() {
    let video = this.refs.video;
    let duration = Math.floor(video.duration);
    let currentTime = Math.floor(video.currentTime);
    let secondsLeft = duration - currentTime;

    let dur = moment.duration(secondsLeft, 'seconds');
    let minutes = dur.minutes().pad(2);
    let seconds = dur.seconds().pad(2);

    this.setState({ min: minutes, sec: seconds });
  }

  seek(event) {
    let video = this.refs.video;
    let x = event.offsetX;
    let w = event.target.offsetWidth;
    let percent = x / w;

    video.currentTime = percent * video.duration;
  }

  componentDidMount() {
    // if (this.props.poster && this.refs.player) {
    //   let poster = this.refs.poster;
    //   /*this.refs.player.addEventListener('canplay',() => {
    //       poster.style.display = 'none'
    //     })*/
    // }

    if (this.props.controls) {
      let video = this.refs.video;

      let progressBar = this.refs.progressContainer;
      let progress = this.refs.progress;
      let _this = this;
      video.controls = false;

      if (video !== undefined) {
        video.addEventListener(
          'timeupdate',
          function () {
            _this.updateProgress();
            _this.timer();
          },
          false
        );

        // sets the prgroess to 0, plays the video and sets the transition state on the progressbar
        video.addEventListener(
          'ended',
          function () {
            _this.setState({ transition: 'transition-off' });
            progress.style.left = 0;

            setTimeout(function () {
              video.play();
              _this.setState({ transition: 'transition-on' });
            }, 100);
          },
          false
        );

        progressBar.addEventListener('mousedown', this.seek, false);
      }
    }
  }

  clickedOff = false;
  audible = false;

  toggleAudio = (evt, clicked = false) => {
    evt.preventDefault();
    console.log('toggling', this.audible, clicked);
    if (!clicked && !this.audible) return false;
    if (this.refs.player && this.props.hasAudio) {
      if (this.refs.player.muted) {
        this.clickedOff = false;
        //this.props.projectClick();
        this.audible = true;
        this.audioOn(true);
      } else {
        this.clickedOff = true;
        this.audioOff();
      }
      //this.refs.player.muted = !this.refs.player.muted
    }
  };

  audioOn = () => {
    //console.log('audioOn', this.props.projectClicked);
    if (!this.audible) return false;
    if (this.refs.player && this.props.hasAudio && !this.clickedOff) {
      let { player, image } = this.refs;
      player.volume = 0;
      player.muted = false;
      player.classList.add('is-loud');
      image.classList.add('is-loud');

      let s = { volume: 0 };

      new TWEEN.Tween(s)
        .to({ volume: 1 }, 1000)
        .onUpdate((o) => {
          player.volume = o.volume;
        })
        .start();

      function animate() {
        if (s.volume < 1) {
          requestAnimationFrame(animate);
          // [...]
          TWEEN.update();
        }
        // [...]
      }

      animate();
    }
  };

  audioOff = () => {
    if (this.refs.player && this.props.hasAudio) {
      let { player, image } = this.refs;
      player.classList.remove('is-loud');
      image.classList.remove('is-loud');

      let s = { volume: 1 };

      this.audible = false;

      new TWEEN.Tween(s)
        .to({ volume: 0 }, 1000)
        .onUpdate((o) => {
          player.volume = o.volume;
        })
        .start();

      function animate() {
        if (s.volume > 0) {
          requestAnimationFrame(animate);
          // [...]
          TWEEN.update();
        } else {
          player.muted = true;
        }
        // [...]
      }

      animate();
    }
  };

  cursorTimer = false;

  showCursor = () => {
    //const _this = this
    const { player } = this.refs;

    player.classList.remove('is-idle');
    clearTimeout(this.cursorTimer);
    // this.cursorTimer = setTimeout(() => {
    //   player.classList.add('is-idle');
    // }, 2000);
  };

  render() {
    const {
      view,
      ratio,
      fluid,
      playOnVisible,
      controls,
      hasAudio,
      poster,
    } = this.props;

    //console.log('playOnVisible', playOnVisible);

    const ratioStyle = {
      paddingTop: 100 / ratio + '%',
    };

    const fluidStyle = {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
    };

    const style = fluid ? fluidStyle : ratioStyle;
    let className = this.props.className || 'video';

    let cls = classNames('Video', { 'has-audio': hasAudio });

    let imgCls = classNames(
      'Image',
      'Image--video',
      { 'Image--has-audio': hasAudio },
      { 'is-playing': this.state.isPlaying }
    );

    if (playOnVisible) {
      return (
        <VisibilitySensor
          onChange={this.onChange}
          partialVisibility={true}
          offsetoff={{ top: -200 }}
        >
          <div
            className={'Image  Image--' + className}
            ref="image"
            style={style}
          >
            <video
              className={
                'Video ' + this.state.playPause + ' ' + this.state.hover
              }
              ref="video"
              onMouseEnter={this._mouseEnter}
              onMouseLeave={this._mouseLeave}
              webkit-playsinline="true"
              playsInline
              muted
              controls={controls}
              autoPlay={this.props.autoplay}
            >
              <source src={this.props.src} type="video/mp4" />
            </video>

            <div className={'Video-controls ' + this.state.hover}>
              <div
                className="Video-controls-container"
                onMouseEnter={this._mouseEnter}
                onMouseLeave={this._mouseLeave}
              >
                <button
                  className={'Video-controls-playPause ' + this.state.playPause}
                  ref="playPause"
                  id="playpause"
                  title="play"
                  onClick={this.togglePlayPause}
                >
                  {this.state.playButton}
                </button>
                <div
                  className="Video-controls-progressContainer"
                  ref="progressContainer"
                >
                  <span className="Video-controls-progressBar"></span>
                  <span
                    className={
                      'Video-controls-progress ' + this.state.transition
                    }
                    ref="progress"
                  ></span>
                </div>
                <div className="Video-controls-timer" id="timer" ref="timer">
                  <span>
                    {this.state.min} . {this.state.sec}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </VisibilitySensor>
      );
    } else {
      return (
        <div
          className={imgCls}
          ref="image"
          style={style}
          data-view={view || 'desktop'}
        >
          {poster && (
            <div className="Video-poster" ref="poster">
              <img src={poster} alt="" />
            </div>
          )}

          <VisibilitySensor onChange={this.togglePlay} partialVisibility={true}>
            <video
              src={this.props.src}
              ref="player"
              className={cls}
              onMouseMove={() => {
                if (!isTouchDevice()) {
                  this.showCursor();
                }
              }}
              onMouseOver={(evt) => {
                if (!isTouchDevice()) {
                  this.audioOn();
                }
              }}
              onMouseOut={(evt) => {
                if (!isTouchDevice()) {
                  this.audioOff();
                }
              }}
              onClick={(evt) => {
                this.toggleAudio(evt, true);
              }}
              webkit-playsinline="true"
              playsInline
              loop
              muted
              controls={controls}
              autoPlay={false}
            />
          </VisibilitySensor>
        </div>
      );
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Video);



// WEBPACK FOOTER //
// ./src/js/components/Video/Video.jsx